import LegalShell from "@/components/LegalShell";
import { COMPANY } from "@/constants/company";

export default function Datenschutz() {
  return (
    <LegalShell title="Datenschutzerklärung" eyebrow="Datenschutz nach DSGVO" testid="datenschutz-page">

      <Section title="1. Verantwortlicher">
        <p>Verantwortlich für die Datenverarbeitung auf dieser Website ist:</p>
        <p className="mt-2">
          <strong>{COMPANY.name}</strong><br />
          {COMPANY.address.street}<br />
          {COMPANY.address.zip} {COMPANY.address.city}<br />
          Telefon: {COMPANY.phone}<br />
          E-Mail: <a href={`mailto:${COMPANY.email}`} className="text-[#C05A44] hover:underline">{COMPANY.emailDisplay}</a>
        </p>
        <p className="mt-2">Geschäftsführer: {COMPANY.managingDirector}</p>
      </Section>

      <Section title="2. Allgemeine Hinweise">
        <p>
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert,
          wenn Sie {COMPANY.appName} nutzen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich
          identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unten
          aufgeführten Datenschutzerklärung.
        </p>
      </Section>

      <Section title="3. Datenerfassung auf dieser Website">
        <h3 className="font-medium text-[#1A2F24] mt-3">a) Registrierung und Konto</h3>
        <p>
          Wenn Sie ein Nutzerkonto erstellen, erheben und speichern wir folgende Daten:
        </p>
        <ul className="list-disc list-inside mt-2 space-y-1">
          <li>E-Mail-Adresse</li>
          <li>Name</li>
          <li>Firmenname (optional)</li>
          <li>Verschlüsseltes Passwort (bcrypt-Hash, das Klartext-Passwort wird nicht gespeichert)</li>
          <li>Spracheinstellung (DE/EN)</li>
          <li>Zeitpunkt der Registrierung</li>
          <li>Aktueller Abonnement-Status</li>
        </ul>
        <p className="mt-2">
          Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
        </p>

        <h3 className="font-medium text-[#1A2F24] mt-5">b) Standortabfragen und Baustellen</h3>
        <p>
          Wenn Sie Adressen oder Geokoordinaten für Standortabfragen eingeben, werden diese — sowie der daraus erzeugte
          Standortbericht — in Ihrem Konto gespeichert, damit Sie später darauf zugreifen können. Die Adressdaten werden zur
          Verarbeitung an die untenstehenden externen Dienste übermittelt.
        </p>

        <h3 className="font-medium text-[#1A2F24] mt-5">c) Cookies</h3>
        <p>
          Wir verwenden ausschließlich technisch notwendige Cookies für die Anmeldung (httpOnly-Session-Cookies mit
          JWT-Token, gültig 1 Stunde Access-Token / 7 Tage Refresh-Token). Es werden keine Tracking- oder
          Marketing-Cookies eingesetzt.
        </p>

        <h3 className="font-medium text-[#1A2F24] mt-5">d) Server-Logfiles</h3>
        <p>
          Der Hosting-Provider erhebt aus technischen Gründen automatisch Logfiles (z.B. IP-Adresse, Zugriffszeitpunkt,
          Browser-Typ). Diese Daten sind anonymisiert und werden ausschließlich zur Sicherstellung des Betriebs verwendet.
          Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).
        </p>
      </Section>

      <Section title="4. Externe Datenverarbeiter und Dienste">
        <p>
          Zur Bereitstellung unserer Standortdaten-Services werden Adressen und Koordinaten an folgende externe Dienste übermittelt:
        </p>
        <ul className="list-disc list-inside mt-3 space-y-2">
          <li>
            <strong>OpenStreetMap Nominatim</strong> (OpenStreetMap Foundation, UK) — Geocoding von Adressen.
            Datenschutz: <a href="https://wiki.osmfoundation.org/wiki/Privacy_Policy" target="_blank" rel="noopener noreferrer" className="text-[#C05A44] hover:underline">osmfoundation.org/wiki/Privacy_Policy</a>
          </li>
          <li>
            <strong>NASA POWER</strong> (NASA Langley Research Center, USA) — Klimadaten.
            Es werden ausschließlich Koordinaten (keine personenbezogenen Daten) übermittelt.
          </li>
          <li>
            <strong>ISRIC SoilGrids</strong> (Wageningen, Niederlande) — Bodendaten.
            Es werden ausschließlich Koordinaten übermittelt.
          </li>
          <li>
            <strong>Bundesanstalt für Geowissenschaften und Rohstoffe (BGR)</strong> (Hannover, Deutschland) —
            bodenkundliche Übersichtskarte. Wird nur abgefragt, wenn für den Standort keine Rasterdaten
            vorliegen; es werden ausschließlich Koordinaten übermittelt.
          </li>
          <li>
            <strong>Open-Elevation</strong> — Höhendaten anhand von Koordinaten.
          </li>
          <li>
            <strong>Stripe Payments Europe Ltd.</strong> (Irland) — Zahlungsabwicklung für Abonnements.
            Datenschutz: <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer" className="text-[#C05A44] hover:underline">stripe.com/de/privacy</a>.
            Übermittelt werden nur die für die Zahlung notwendigen Daten (E-Mail, Zahlungsbetrag, Plan-ID).
            Kreditkartendaten werden ausschließlich bei Stripe verarbeitet und niemals auf unseren Servern gespeichert.
          </li>
          <li>
            <strong>Bundesamt für Kartographie und Geodäsie (BKG)</strong> (Frankfurt am Main, Deutschland) —
            Kartenkacheln für die interaktive Karte (TopPlusOpen). Der Kartendienst erhält beim Laden der Kacheln
            Ihre IP-Adresse und den dargestellten Kartenausschnitt. Die Server stehen in Deutschland;
            eine Übermittlung in Drittländer findet nicht statt.
          </li>
        </ul>
        <p className="mt-3">
          Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) bzw. lit. f (berechtigtes Interesse an
          Bereitstellung der Standortdaten).
        </p>
      </Section>

      <Section title="5. Datenübermittlung in Drittländer">
        <p>
          Bei der Nutzung von NASA POWER (USA) erfolgt eine Übermittlung von Geokoordinaten in die USA. Da hierbei keine
          personenbezogenen Daten übermittelt werden (nur anonyme Koordinaten), liegt keine Übermittlung im Sinne der
          DSGVO vor.
        </p>
      </Section>

      <Section title="6. Speicherdauer">
        <p>
          Wir speichern Ihre Daten so lange, wie Ihr Konto besteht. Nach Kündigung Ihres Kontos werden personenbezogene
          Daten innerhalb von 30 Tagen gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten (z.B. Rechnungen
          gemäß § 257 HGB / § 147 AO: 10 Jahre) entgegenstehen.
        </p>
      </Section>

      <Section title="7. Geteilte Berichte (Sharing-Funktion)">
        <p>
          Wenn Sie die Sharing-Funktion aktivieren, wird ein zufälliger, nicht-erratbarer Link erzeugt. Über diesen Link
          können Dritte ohne Anmeldung den Bericht einsehen. Sie können diesen Link jederzeit deaktivieren — danach ist
          der Link nicht mehr aufrufbar. Es werden keinerlei personenbezogenen Daten des Endkunden erhoben, der den Link
          aufruft (lediglich anonyme Aufrufzahlen).
        </p>
      </Section>

      <Section title="8. Ihre Rechte als Betroffener">
        <p>Sie haben jederzeit folgende Rechte:</p>
        <ul className="list-disc list-inside mt-2 space-y-1">
          <li>Auskunft über die zu Ihrer Person gespeicherten Daten (Art. 15 DSGVO)</li>
          <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
          <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
          <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
        </ul>
        <p className="mt-3">
          Zur Ausübung Ihrer Rechte wenden Sie sich an: <a href={`mailto:${COMPANY.privacyEmail}`} className="text-[#C05A44] hover:underline">{COMPANY.privacyEmailDisplay}</a>
        </p>
      </Section>

      <Section title="9. Datensicherheit">
        <p>
          Wir verwenden ausschließlich verschlüsselte HTTPS-Verbindungen (TLS). Passwörter werden mit bcrypt
          (industriestandard, Salted) gehasht und niemals im Klartext gespeichert. Login-Versuche werden gegen
          Brute-Force-Angriffe abgesichert (Sperre nach 5 Fehlversuchen für 15 Minuten).
        </p>
      </Section>

      <Section title="10. Änderungen dieser Datenschutzerklärung">
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen
          Anforderungen entspricht oder um Änderungen unserer Leistungen umzusetzen.
        </p>
        <p className="mt-3 text-xs text-[#5C6B61]">
          Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}
        </p>
      </Section>
    </LegalShell>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="font-display font-semibold text-xl text-[#1A2F24] mb-3">{title}</h2>
      <div className="text-sm leading-relaxed text-[#1A2F24]/85 space-y-1">{children}</div>
    </section>
  );
}
